import ajax from "./modules/ajax";
import ui from "./modules/ui";
import QRCode from "qrcode";
import { saveAs } from "file-saver";

export const simpleAction = (url: string, element: HTMLElement): void => {
  element.innerHTML =
    "<i class='fas fa-circle-notch text-info fa-fw fa-spin'></i>";

  ajax.get(url).then((response) => {
    const titleError = response.errors.join("");
    const titleOk = response.messages.join("");
    element.innerHTML = response.error
      ? `<span title='${titleError}'><i class='fas fa-exclamation-circle text-danger fa-fw'></i></span>`
      : `<span title='${titleOk}'><i class='fas fa-check-circle text-success fa-fw'></i></span>`;
  });
};

export const downloadFileAction = (
  url: string,
  element: HTMLElement,
  filename: string
): void => {
  element.innerHTML =
    "<i class='fas fa-circle-notch text-info fa-fw fa-spin'></i>";

  const req = new XMLHttpRequest();
  req.open("GET", url, true);
  req.responseType = "blob";

  req.onreadystatechange = () => {
    if (req.status !== 200) {
      element.innerHTML = `<span title='Hubo un error descargando el archivo: ${filename}'><i class='fas fa-exclamation-circle text-danger fa-fw'></i></span>`;
    }

    if (req.readyState === 4 && req.status === 200) {
      saveAs(req.response, filename);
      element.innerHTML = `<span title='Archivo descargado'><i class='fas fa-check-circle text-success fa-fw'></i></span>`;
    }
  };
  req.send();
};

export const edit = (url: string, id: number) => {
  return ui.edit(url, { id });
};

export const create = (url: string, data: Record<string, unknown>) => {
  return ui.create(url, data);
};

export const downloadQR = (event: Event, element: HTMLElement): void => {
  event.stopPropagation();

  const url = element.dataset.url;
  const difunto = element.dataset.difunto;

  QRCode.toDataURL(url as string, (_err, string) => {
    saveAs(string, `QR code link familias - ${difunto}.png`);
  });
};
